/**
 * Embed context set by a host before the viewer boots (JEP-10750).
 *
 * The Jepto MCP `view_report` app renders this viewer inside Claude / ChatGPT and
 * puts the tool result on `window.__JEPTO_EMBED__` before loading the bundle.
 * `viewerToken` is a `JeptoViewer` wrapper JWT minted for the report's owner so
 * private and hidden shares render without the email-code gate.
 */
export interface JeptoEmbedContext {
	shareId?: string;
	pageId?: string | null;
	viewerToken?: string;
}

declare global {
	interface Window {
		__JEPTO_EMBED__?: JeptoEmbedContext;
	}
}

/** Returns the embed viewer token for `reportId`, or null when absent, missing a `shareId`, or for another report. */
export function readEmbedViewerToken(reportId: string): string | null {
	if (typeof window === 'undefined') {
		return null;
	}
	const embed = window.__JEPTO_EMBED__;
	const token = embed?.viewerToken?.trim();
	if (!token) {
		return null;
	}
	const shareId = embed?.shareId?.trim().toLowerCase();
	if (!shareId || shareId !== reportId.trim().toLowerCase()) {
		return null;
	}
	return token;
}
